import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Get, GetImage, Post, Put } from "../api/api";
import { showNotification } from "./commonSlice";
import {
  BodyAndParamsInterface,
  CreateInterface,
  DeleteInterface,
  GetInterface,
  ListInterface,
  PagingInterface,
  UpdateInterface,
  initialState,
} from "./crudSlice.entity";

export const createAPI: any = createAsyncThunk(
  "crud/create",
  async ({ key, url, request }: CreateInterface, { dispatch }) => {
    try {
      // dispatch(showLoader({ isLoaderOpen: true }));
      const response: any = await Post(`${url}`, request);
      if (response?.statusCode === 201 || response?.success) {
        // dispatch(showLoader({ isLoaderOpen: false }));
        dispatch(
          showNotification({
            isOpen: true,
            message: "Created Successfully",
            type: "success",
          })
        );
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      } else {
        // dispatch(showLoader({ isLoaderOpen: false }));
        // dispatch(
        //     showNotification({
        //         isOpen: true,
        //         message: response?.data?.message,
        //         type: "error",
        //     })
        // );
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      }
    } catch (e: any) {
      dispatch(
        showNotification({
          isOpen: true,
          message: e?.data?.message,
          type: "error",
        })
      );
      if (key !== "") {
        return { key, value: {} };
      } else {
        return e;
      }
    }
  }
);

export const getListAPI: any = createAsyncThunk(
  "crud/getList",
  async ({ key, url }: GetInterface, { dispatch }) => {
    try {
      // dispatch(showLoader({ isLoaderOpen: true }));
      const response: any = await Get(`${url}`);
      if (response?.statusCode === 200) {
        // dispatch(showLoader({ isLoaderOpen: false }));
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      } else {
        // dispatch(showLoader({ isLoaderOpen: false }));
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      }
    } catch (e: any) {
      dispatch(
        showNotification({
          isOpen: true,
          message: e?.data?.message,
          type: "error",
        })
      );
      if (key !== "") {
        return { key, value: {} };
      } else {
        return e;
      }
    }
  }
);

export const getListByParamsAPI: any = createAsyncThunk(
  "crud/getListByParams",
  async ({ key, url, params }: PagingInterface, { dispatch }) => {
    try {
      // dispatch(showLoader({ isLoaderOpen: true }));
      const response: any = await Get(`${url}`, { params: { ...params } });
      if (response?.statusCode === 200) {
        // dispatch(showLoader({ isLoaderOpen: false }));
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      } else {
        // dispatch(showLoader({ isLoaderOpen: false }));

        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      }
    } catch (e: any) {
      dispatch(
        showNotification({
          isOpen: true,
          message: e?.data?.message,
          type: "error",
        })
      );
      if (key !== "") {
        return { key, value: {} };
      } else {
        return e;
      }
    }
  }
);

export const getByParamsAPI: any = createAsyncThunk(
  "crud/getByParams",
  async ({ key, url, params }: PagingInterface, { dispatch }) => {
    try {
      // dispatch(showLoader({ isLoaderOpen: true }));
      const response: any = await Post(`${url}`, { params: { ...params } });
      if (response?.statusCode === 200) {
        // dispatch(showLoader({ isLoaderOpen: false }));
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      } else {
        // dispatch(showLoader({ isLoaderOpen: false }));
        // dispatch(
        //     showNotification({
        //         isOpen: true,
        //         message: response?.data?.message,
        //         type: "error",
        //     })
        // );
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      }
    } catch (e: any) {
      dispatch(
        showNotification({
          isOpen: true,
          message: e?.data?.message,
          type: "error",
        })
      );
      if (key !== "") {
        return { key, value: {} };
      } else {
        return e;
      }
    }
  }
);

export const getByBodyAPI: any = createAsyncThunk(
  "crud/getByBody",
  async ({ key, url, request }: ListInterface, { dispatch }) => {
    try {
      // dispatch(showLoader({ isLoaderOpen: true }));
      const response: any = await Post(`${url}`, request);
      if (response?.statusCode === 200) {
        // dispatch(showLoader({ isLoaderOpen: false }));
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      } else {
        // dispatch(showLoader({ isLoaderOpen: false }));
        dispatch(
          showNotification({
            isOpen: true,
            message: response?.data?.message,
            type: "error",
          })
        );
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      }
      // return response;
    } catch (e: any) {
      dispatch(
        showNotification({
          isOpen: true,
          message: e?.data?.message,
          type: "error",
        })
      );
      if (key !== "") {
        return { key, value: {} };
      } else {
        return e;
      }
    }
  }
);

export const getByBodyAndParamsAPI: any = createAsyncThunk(
  "crud/getByBodyAndParams",
  async (
    { key, url, request, params }: BodyAndParamsInterface,
    { dispatch }
  ) => {
    try {
      // dispatch(showLoader({ isLoaderOpen: true }));
      const response: any = await Post(`${url}`, request, {
        params: { ...params },
      });
      if (response?.statusCode === 200) {
        // dispatch(showLoader({ isLoaderOpen: false }));
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      } else {
        // dispatch(showLoader({ isLoaderOpen: false }));
        dispatch(
          showNotification({
            isOpen: true,
            message: response?.data?.message,
            type: "error",
          })
        );
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      }
    } catch (e: any) {
      dispatch(
        showNotification({
          isOpen: true,
          message: e?.data?.message,
          type: "error",
        })
      );
      if (key !== "") {
        return { key, value: {} };
      } else {
        return e;
      }
    }
  }
);

export const getByIdAPI: any = createAsyncThunk(
  "crud/getById",
  async ({ key, url, params = {} }: GetInterface, { dispatch }) => {
    try {
      // dispatch(showLoader({ isLoaderOpen: true }));
      const response: any = await Get(`${url}`, {
        params: { ...params },
      });
      if (response?.statusCode === 200) {
        // dispatch(showLoader({ isLoaderOpen: false }));
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      } else {
        // dispatch(showLoader({ isLoaderOpen: false }));
        dispatch(
          showNotification({
            isOpen: true,
            message: response?.data?.message,
            type: "error",
          })
        );
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      }
    } catch (e: any) {
      dispatch(
        showNotification({
          isOpen: true,
          message: e?.data?.message,
          type: "error",
        })
      );
      if (key !== "") {
        return { key, value: e?.response || {} };
      } else {
        return e?.response || {};
      }
    }
  }
);

export const getPagingAPI: any = createAsyncThunk(
  "crud/paging",
  async ({ key, url, params }: PagingInterface, { dispatch }) => {
    try {
      // dispatch(showLoader({ isLoaderOpen: true }));
      const response: any = await Get(`${url}`, {
        params: { ...params },
      });
      if (response?.statusCode === 200) {
        // dispatch(showLoader({ isLoaderOpen: false }));
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      }
      if (response === undefined) {
        // dispatch(showLoader({ isLoaderOpen: false }));
        return { key, value: [] };
      } else {
        dispatch(
          showNotification({
            isOpen: true,
            message: response?.data?.message,
            type: "error",
          })
        );
        // dispatch(showLoader({ isLoaderOpen: false }));
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      }
    } catch (e: any) {
      dispatch(
        showNotification({
          isOpen: true,
          message: e?.data?.message,
          type: "error",
        })
      );
      if (key !== "") {
        return { key, value: {} };
      } else {
        return e;
      }
    }
  }
);
//
export const updateAPI: any = createAsyncThunk(
  "crud/update",
  async ({ key, url, request }: UpdateInterface, { dispatch }) => {
    try {
      // dispatch(showLoader({ isLoaderOpen: true }));
      const response: any = await Put(`${url}`, request);
      if (response?.statusCode === 200) {
        // dispatch(showLoader({ isLoaderOpen: false }));
        dispatch(
          showNotification({
            isOpen: true,
            message: "Updated successfully",
            type: "success",
          })
        );
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      } else {
        // dispatch(showLoader({ isLoaderOpen: false }));
        // dispatch(
        //     showNotification({
        //         isOpen: true,
        //         message: response?.data?.message,
        //         type: "error",
        //     })
        // );
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      }
    } catch (e: any) {
      dispatch(
        showNotification({
          isOpen: true,
          message: e?.data?.message,
          type: "error",
        })
      );
      return e;
    }
  }
);

export const deleteAPI: any = createAsyncThunk(
  "crud/delete",
  async ({ url, request }: DeleteInterface, { dispatch }) => {
    // dispatch(showLoader({ isLoaderOpen: true }));
    const response: any = await Put(`${url}`, request);
    if (response?.statusCode === 200) {
      // dispatch(showLoader({ isLoaderOpen: false }));
      dispatch(
        showNotification({
          isOpen: true,
          message: "Deleted successfully",
          type: "success",
        })
      );
      return response;
    } else {
      // dispatch(showLoader({ isLoaderOpen: false }));
      // dispatch(
      //     showNotification({
      //         isOpen: true,
      //         message: response?.data?.message,
      //         type: "error",
      //     })
      // );
      return response;
    }
  }
);

export const uploadImageAPI: any = createAsyncThunk(
  "crud/upload",
  async ({ key, url, request }: any, { dispatch }) => {
    // dispatch(showLoader({ isLoaderOpen: true }));
    try {
      const formData = new FormData();
      formData.append("form-data", request?.data);

      const response: any = await Post(
        url,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            systemname: request?.systemname,
          },
        }
      );

      if (response?.statusCode === 201 || response?.statusCode === 200) {
        // dispatch(showLoader({ isLoaderOpen: false }));
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      } else {
        // dispatch(showLoader({ isLoaderOpen: false }));
        dispatch(
          showNotification({
            isOpen: true,
            message: response?.data?.message,
            type: "error",
          })
        );
        if (key !== "") {
          return { key, value: response };
        } else {
          return response;
        }
      }
    } catch (e: any) {
      dispatch(
        showNotification({
          isOpen: true,
          message: e?.data?.message,
          type: "error",
        })
      );
      if (key !== "") {
        return { key, value: {} };
      } else {
        return e;
      }
    }
  }
);

export const getImageAPI: any = createAsyncThunk(
  "crud/getImage",
  async ({ key, url }: any, { dispatch }) => {
    try {
      // dispatch(showLoader({ isLoaderOpen: true }));
      const response: any = await GetImage(url, { responseType: "blob" });
      if (key !== "") {
        return { key, value: response };
      } else {
        return response;
      }
    } catch (e: any) {
      dispatch(
        showNotification({
          isOpen: true,
          message: e?.data?.message,
          type: "error",
        })
      );
      if (key !== "") {
        return { key, value: {} };
      } else {
        return e;
      }
    }
  }
);

export const crudSlice = createSlice({
  name: "Crud",
  initialState,
  reducers: {
    setReducerState: (
      state,
      action: PayloadAction<{ key: string; value: any }>,
    ) => {
      const { key, value } = action.payload;
      return { ...state, [key]: value };
    },
  },
  extraReducers: (builder) => {
    builder
      // createAPI
      .addCase(createAPI.pending, (state, action) => {
        const { key } = action?.meta?.arg;
        state[`isLoading${key}`] = "loading";
      })
      .addCase(
        createAPI.fulfilled,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "idle";
          state[key] = value;
        }
      )
      .addCase(
        createAPI.rejected,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "failed";
          state[key] = [];
        }
      )

      // updateAPI
      .addCase(updateAPI.pending, (state, action) => {
        const { key } = action?.meta?.arg;
        state[`isLoading${key}`] = "loading";
      })
      .addCase(
        updateAPI.fulfilled,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "idle";
          state[key] = value;
        }
      )
      .addCase(
        updateAPI.rejected,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "failed";
          state[key] = [];
        }
      )

      // getListAPI
      .addCase(getListAPI.pending, (state, action) => {
        const { key } = action?.meta?.arg;
        state[`isLoading${key}`] = "loading";
      })
      .addCase(
        getListAPI.fulfilled,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "idle";
          state[key] = value;
        }
      )
      .addCase(
        getListAPI.rejected,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "failed";
          state[key] = [];
        }
      )

      // getListByParamsAPI
      .addCase(getListByParamsAPI.pending, (state, action) => {
        const { key } = action?.meta?.arg;
        state[`isLoading${key}`] = "loading";
      })
      .addCase(
        getListByParamsAPI.fulfilled,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "idle";
          state[key] = value;
        }
      )
      .addCase(
        getListByParamsAPI.rejected,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "failed";
          state[key] = [];
        }
      )

      // getByParamsAPI
      .addCase(getByParamsAPI.pending, (state, action) => {
        const { key } = action?.meta?.arg;
        state[`isLoading${key}`] = "loading";
      })
      .addCase(
        getByParamsAPI.fulfilled,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "idle";
          state[key] = value;
        }
      )
      .addCase(
        getByParamsAPI.rejected,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "failed";
          state[key] = [];
        }
      )

      // getByBodyAPI
      .addCase(getByBodyAPI.pending, (state, action) => {
        const { key } = action?.meta?.arg;
        state[`isLoading${key}`] = "loading";
      })
      .addCase(
        getByBodyAPI.fulfilled,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          if (action?.payload) {
            const { key, value } = action?.payload;
            state[`isLoading${key}`] = "idle";
            state[key] = value;
          }
        }
      )
      .addCase(
        getByBodyAPI.rejected,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "failed";
          state[key] = [];
        }
      )

      // getByBodyAndParamsAPI
      .addCase(getByBodyAndParamsAPI.pending, (state, action) => {
        const { key } = action?.meta?.arg;
        state[`isLoading${key}`] = "loading";
      })
      .addCase(
        getByBodyAndParamsAPI.fulfilled,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "idle";
          state[key] = value;
        }
      )
      .addCase(
        getByBodyAndParamsAPI.rejected,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "failed";
          state[key] = [];
        }
      )

      // getByIdAPI
      .addCase(getByIdAPI.pending, (state, action) => {
        const { key } = action?.meta?.arg;
        state[`isLoading${key}`] = "loading";
      })
      .addCase(
        getByIdAPI.fulfilled,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "idle";
          state[key] = value;
        }
      )
      .addCase(
        getByIdAPI.rejected,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "failed";
          state[key] = [];
        }
      )

      // getPagingAPI
      .addCase(getPagingAPI.pending, (state, action) => {
        const { key } = action?.meta?.arg;
        state[`isLoading${key}`] = "loading";
      })
      .addCase(
        getPagingAPI.fulfilled,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "idle";
          state[key] = value;
        }
      )
      .addCase(
        getPagingAPI.rejected,
        (state, action: PayloadAction<{ key: string; value: any }>) => {
          const { key, value } = action?.payload;
          state[`isLoading${key}`] = "failed";
          state[key] = [];
        }
      );
  },
});

export const { setReducerState } = crudSlice.actions;
const crudReducer = crudSlice.reducer;
export default crudReducer;
